// eslint-disable-next-line import/prefer-default-export
export const featureFlagsKeys = {
  base: ['featureFlags'] as const,
};
